import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Image from 'next/image';
import * as AuthAPI from '@src/lib/api/auth';

export const SocialComponent = () => {
  const [kakaoEmail, setKakaoEmail] = useState('');
  // const [kakaoPhone, setKakaoPhone] = useState('');
  const [isMember, setIsMember] = useState();

  /* 카카오 로그인 기존 코드 그대로 사용 */
  // Kakao login
  useEffect(() => {
    if (kakaoEmail) {
      checkIsMember(kakaoEmail)
        .then((res) => {
          setIsMember(res);
        })
        .catch((error) => setIsMember(false));
    }
  }, [kakaoEmail]);

  useEffect(() => {
    if (kakaoEmail) {
      const email = kakaoEmail;
      // const phone = kakaoPhone;

      // Case 1 - already a member -> login
      if (isMember) {
        postSocialLogin({ email });
      }
      // Case 2 - not a member -> register
      else {
        const channel = 'kakao';
        postSocialRegister({ email, channel });
      }
    }
  }, [isMember]);

  const handleKakaoLogin = () => {
    window.Kakao?.Auth.login({
      // Get user data if success
      success: function (temp) {
        // Get user data
        window.Kakao?.API.request({
          url: '/v2/user/me',
          success: function (reqRes) {
            const { email } = reqRes.kakao_account;
            setKakaoEmail(email);
            // setKakaoPhone(phone_number);
          },
          fail: function (reqError) {
            alert('카카오 로그인에 실패했습니다. 조금 후 다시 시도해주세요!');
            console.log(reqError);
          },
        });
      },
      fail: function (loginError) {
        //kakaoUnregister();
        alert('카카오 로그인에 실패했습니다. 조금 후 다시 시도해주세요!');
        console.log(loginError);
      },
    });
  };

  const checkIsMember = async (email) => {
    try {
      const res = await AuthAPI.checkEmailExists(email);
      return res.data.data;
    } catch (e) {
      console.log(e);
    }
  };

  const postSocialLogin = async ({ email }) => {
    try {
      const res = await AuthAPI.socialLogin({ email });
      // Succeed
      if (res.status === 200) {
        window.location.replace('/');
      }
    } catch (err) {
      //kakaoUnregister();
      alert('로그인에 문제가 생겼습니다. 잠시 후 다시 시도해 주세요.');
      console.log('postSocialLogin', err);
    }
  };

  const postSocialRegister = async ({ email, channel }) => {
    try {
      const res = await AuthAPI.socialRegister({ email, channel });

      // Succeed
      if (res.status === 200) {
        // Check if JWT is valid
        window.location.replace('verify');
      }
    } catch (err) {
      console.log(err);
      alert('가입에 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.');
    }
  };

  return (
    <SocialContainer>
      <Title>간편회원가입</Title>
      <ImageWarp>
        <Image
          src='/kakao_login_large_wide.png'
          alt='kakaoLogin'
          layout='intrinsic'
          width={600}
          height={90}
          onClick={handleKakaoLogin}
        />
      </ImageWarp>
    </SocialContainer>
  );
};

const SocialContainer = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 5.5rem;
  border-bottom: 1px solid #c4c4c4;
  @media screen and (max-width: 992px) {
    padding: 4rem 2rem;
  }
`;

const Title = styled.header`
  text-align: center;
  font-weight: bold;
  font-size: 23px;
`;

const ImageWarp = styled.div`
  display: block;
  margin-top: 44px;
  max-width: 720px;
  text-align: center;
  cursor: pointer;
`;
